import api from '../api';

const ADMIN_URL = '/admins';
const ADMIN_DETAIL_URL = '/admins/:id';
const ADMIN_RESET_URL = '/admins/reset/password';

function mapAdminRequestBody(admin) {
  return {
    ...admin,
    regions: admin.regions
      ? admin.regions.map((region) => ({
          code: region.code,
        }))
      : undefined,
  };
}

export async function createAdmin({ data }) {
  return api.post(ADMIN_URL, mapAdminRequestBody(data));
}

export async function updateAdmin({ id, data }) {
  return api.put(
    ADMIN_DETAIL_URL.replace(':id', id),
    mapAdminRequestBody(data),
  );
}

export async function resetPasswordAdmin(data) {
  return api.put(ADMIN_RESET_URL, data);
}
